import cx from 'classnames';
import PropTypes from 'prop-types';

import PlusIcon from 'src/assets/icons/Plus';
import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';

import { WIDGET_ACTION } from '../../lib';

import { useStyles } from './useStyles';

export const Actions = ({ className, onAction, disabled }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.createBlankProject)}
        disabled={disabled}
        startIcon={<PlusIcon />}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonNewBlankProject"
      >
        New blank project
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.improveContent)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonImproveContent"
      >
        Improve existing content
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.openTemplateGallery)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonTemplateGallery"
      >
        Template gallery
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.openSavedTemplates)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonSavedTemplates"
      >
        Saved templates
      </CustomButton>
    </div>
  );
};

Actions.propTypes = {
  className: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Actions.defaultProps = {
  className: null,
  disabled: false,
};
